import Vue from "vue";
import funcaoSocio from "../dados/funcao-socio.json";
import atividadeSimples from "../dados/atividades-simples.json";

Vue.filter('tipoPessoa', function (value) {
    switch (parseInt(value)) {
        case 921:
            return "Autônomo";
        case 922:
            return "Avulso";
        case 923:
            return "Prestador";
        case 924:
            return "Não Prestador";
        case 925:
            return "Escritório de Contabilidade";
        case 926:
            return "Cartório";
        case 929:
            return "Instituição Financeira";
        default:
            return value;
    }
});

Vue.filter('tipoPessoaTabNumero', function (value) {
    switch (parseInt(value)) {
        case 1:
            return "Autônomo";
        case 2:
            return "Avulso";
        case 3:
            return "Prestador";
        case 4:
            return "Não Prestador";
        case 5:
            return "Escritório de Contabilidade";
        case 6:
            return "Cartório";
        case 11:
            return "Instituição Financeira";
        default:
            return value;
    }
});

Vue.filter('portePessoa', function (value) {
    switch (parseInt(value)) {
        case 1:
            return "Microempreendedor Individual (MEI)";
        case 2:
            return "Microempresa (ME)";
        case 3:
            return "Empresa de Pequeno Porte (EPP)";
        case 4:
            return "Empresa de Médio Porte";
        case 99:
            return "Demais";
        default:
            return value;
    }
});

Vue.filter('tributacaoPessoa', function (value) {
    switch (parseInt(value)) {
        case 1:
            return "Microempreendedor Individual";
        case 2:
            return "Simples Nacional";
        case 3:
            return "Estimativo";
        case 4:
            return "Sociedade de Profissionais";
        case 5:
            return "Cooperativas";
        case 6:
            return "Sem Tributação Especial";
        default:
            return value;
    }
});

Vue.filter('estabelecimentoPessoa', function (value) {
    switch (parseInt(value)) {
        case 1:
            return "Matriz";
        case 2:
            return "Filial";
        case 3:
            return "Representação";
        case 4:
            return "Caixa Eletrônico";
        case 5:
            return "Torre Transmissão";
        case 6:
            return "Depósito/Almoxarifado";
        case 7:
            return "Garagem";
        case 8:
            return "Posto de Coleta";
        case 9:
            return "Ponto Quiosque/Exposição";
        case 10:
            return "Ponto Outdoor/Publicidade";
        case 99:
            return "Outros";
        default:
            return value;
    }
});

Vue.filter('exigibilidadeIss', function (value) {
    switch (parseInt(value)) {
        case 1:
            return "Exigível";
        case 2:
            return "Não incidência";
        case 3:
            return "Isenção";
        case 4:
            return "Exportação";
        case 5:
            return "Imunidade";
        case 6:
            return "Exigibilidade Suspensa por Decisão Judicia";
        case 7:
            return "Exigibilidade Suspensa por Processo Administrativo";
        default:
            return value;
    }
});

Vue.filter('socioQualificacao', function (value) {
    if (!value) {
        return "Não informado";
    }
    for (let f in funcaoSocio) {
        if (funcaoSocio[f].codigo === parseInt(value)) {
            return funcaoSocio[f].descricao
        }
    }
});

Vue.filter('receitasSimplesNacional', function (value) {
    switch (parseInt(value)) {
        case 1001:
            return "IRPJ";
        case 1002:
            return "CSLL";
        case 1004:
            return "COFINS";
        case 1005:
            return "PIS";
        case 1006:
            return "INSS";
        case 1007:
            return "ICMS";
        case 1008:
            return "IPI";
        case 1010:
            return "ISS";
        case 1012:
            return "MULTA IRPJ";
        case 1013:
            return "MULTA CSLL";
        case 1014:
            return "MULTA COFINS";
        case 1015:
            return "MULTA PIS";
        case 1017:
            return "MULTA INSS";
        case 1018:
            return "MULTA ICMS";
        case 1019:
            return "MULTA IPI";
        case 1021:
            return "MULTA ISS";
        case 1023:
            return "JUROS IRPJ";
        case 1025:
            return "JUROS CSLL";
        case 1026:
            return "JUROS COFINS";
        case 1027:
            return "JUROS PIS";
        case 1028:
            return "JUROS INSS";
        case 1029:
            return "JUROS ICMS";
        case 1030:
            return "JUROS IPI";
        case 1031:
            return "JUROS ISS";
        default:
            return value;
    }
});

Vue.filter('uaSimples', function (obj) {
    if (obj.mun_codigo) {
        return obj.mun_codigo.mun_nome+' - '+obj.mun_codigo.mun_uf;
    }
    if (obj.uf !== '') {
        return obj.uf;
    }
    return "União";
});

Vue.filter('ativiadeSimples', function (value) {
    if (!value) {
        return value;
    }
    for (let a in atividadeSimples) {
        if (atividadeSimples[a].codigo === parseInt(value)) {
            return atividadeSimples[a].descricao
        }
    }
});

Vue.filter('motivoCancelamento', function (value) {
    switch (parseInt(value)) {
        case 1:
            return "Erro na Emissão";
        case 2:
            return "Serviço não prestado";
        case 9:
            return "Outros";
        default:
            return value;
    }
});
